// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__pNtuQ","tab":"ProcedureTabs_tab__2kEtb"};